<div class="min-w-[600px] max-w-2xl font-inter">
  <div class="mb-4">Separate Vendor Contract names by using line breaks</div>

  @if ((isLoading$ | async) === true) {
    <div class="spinner m-auto my-16 h-32 w-32 border-8"></div>
  }

  @if ((isLoading$ | async) === false) {
    <aux-input #vendors class="vendors-textarea" [textArea]="true" />
  }
</div>
